export default __webpack_public_path__ + "static/media/spark-plug.d2302518.svg";